// This file is generated automatically, do not overwrite

export enum RateDeviationType {
  CHECKING_ACCOUNT = 'checking_account',
  ENERGY_STANDARD = 'energy_standard',
  FOR_RENT = 'for_rent',
  NEW_HOME = 'new_home',
  QUOTATION_INTEREST_DISCOUNT = 'quotation_interest_discount',
  RECREATION_HOUSE = 'recreation_house',
  OTHER = 'other',
}

const RateDeviationTypeTranslations = new Map<RateDeviationType, string>();

RateDeviationTypeTranslations.set(RateDeviationType.CHECKING_ACCOUNT, 'Betaalrekening');
RateDeviationTypeTranslations.set(RateDeviationType.ENERGY_STANDARD, 'Energielabel');
RateDeviationTypeTranslations.set(RateDeviationType.FOR_RENT, 'Voor verhuur');
RateDeviationTypeTranslations.set(RateDeviationType.NEW_HOME, 'Nieuwbouw');
RateDeviationTypeTranslations.set(RateDeviationType.QUOTATION_INTEREST_DISCOUNT, 'Offerterente korting');
RateDeviationTypeTranslations.set(RateDeviationType.RECREATION_HOUSE, 'Recreatiewoning');
RateDeviationTypeTranslations.set(RateDeviationType.OTHER, 'Anders');

const translateRateDeviationType = (enumeration: RateDeviationType): string => {
  return RateDeviationTypeTranslations.get(enumeration);
}

export { RateDeviationTypeTranslations, translateRateDeviationType }